import { render, staticRenderFns } from "./CustomerSwitcher.vue?vue&type=template&id=71e5cb87&scoped=true"
import script from "./CustomerSwitcher.vue?vue&type=script&lang=js"
export * from "./CustomerSwitcher.vue?vue&type=script&lang=js"
import style0 from "./CustomerSwitcher.vue?vue&type=style&index=0&id=71e5cb87&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71e5cb87",
  null
  
)

export default component.exports